<template>
  <div>
    <div class="page-wrap">
      <h2 class="title-page fw-500">
        <i class="fas fa-book mr-2"></i>สรุปยอดฝากเงินในบัญชีฝาก
      </h2>
      <div class="body-content">
        <p class="mt-3">สรุปยอดฝากเงินในบัญชีฝาก</p>
        <div class="row">
          <div class="col-md-4">
            <date-picker
              class="input-date w-100"
              valueType="format"
              type="date"
              lang="en"
              v-model="payload.date"
              v-on:change="onchange"
            ></date-picker>
          </div>
        </div>
        <div class="table-content">
          <mdb-datatable
            :arrows="true"
            :data="tableData"
            striped
            bordered
            :searching="false"
            scrollY
            maxHeight="450px"
            v-if="reloading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var axios = require("axios");
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      reloading: false,
    //   dateselect1: "",
      selectbank: [],
      payload: {
        date: moment().format("YYYY-MM-DD"),
        bank_number: "",
      },
      tableData: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
          },
          {
            label: "ธนาคาร",
            field: "bank_code",
            sort: true,
          },
          {
            label: "เลขบัญชี",
            field: "bank_number",
            sort: true,
          },
          {
            label: "ยอดฝากทั้งหมด",
            field: "total",
            sort: true,
          },
            {
            label: "ยอดฝาก",
            field: "deposit",
            sort: true,
          },
            {
            label: "ยอดตกค้าง",
            field: "deposit_remain",
            sort: true,
          },
            {
            label: "ชื่อบัญชี",
            field: "bank_name",
            sort: true,
          },
          {
            label: "เงินในบัญชีปัจจุบัน",
            field: "amount",
            sort: true,
          },
          {
            label: "อัพเดทล่าสุด",
            field: "update_datetime",
            sort: true,
          },
        ],
        rows: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      tokens: "tokens",
    }),
    data() {
      return {
        columns: [],
        rows: [],
      };
    },
    
  },
  async mounted() {
    this.reloading = true;
    this.getStatementByDate();
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
    }),

    async onchange() {
      this.getStatementByDate();
     
    },

    async getStatementByDate() {
      this.tableData.rows = null;
        this.reloading = false;
      const token = jwt.sign(this.payload, this.$keypayload);
      var config = {
        method: "POST",
        url: "https://sms-fast.warmlight.online/api/getDepositSummary",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: { token: token },
      };
      await axios(config)
        .then((response) => {
          this.$nextTick(() => {
            this.reloading = true;
          });

          this.tableData.rows = this.$add_index(response.data.payload);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>

</style>
